
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Topbar({ toggleSidebar, sidebarOpen }) {

    const navigate = useNavigate();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("user");

        navigate("/");
    };

    // Close dropdown when clicking outside
    useEffect(() => {

        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);

    return (

        <nav className="navbar navbar-dark bg-dark shadow-sm px-3">

            {/* Left Side */}
            <div className="d-flex align-items-center gap-3">

                {/* Sidebar Toggle */}
                <button
                    type="button"
                    className="btn btn-outline-light border-0"
                    onClick={toggleSidebar}
                    title={sidebarOpen ? "Close Sidebar" : "Open Sidebar"}
                >
                    <i className="bi bi-list fs-3"></i>
                </button>

                {/* Application Title */}
                <h4 className="text-white mb-0">
                    Transport Management
                </h4>

            </div>

            {/* Right Side - User Dropdown */}
            <div className="position-relative" ref={dropdownRef}>

                <button
                    type="button"
                    className="btn btn-outline-light border-0 rounded-circle"
                    onClick={() => setDropdownOpen(prev => !prev)}
                    title="User Account"
                >
                    <i className="bi bi-person-circle fs-2"></i>
                </button>

                {dropdownOpen && (

                    <div
                        className="dropdown-menu dropdown-menu-end show shadow"
                        style={{
                            position: "absolute",
                            right: 0,
                            top: "100%",
                            minWidth: "180px",
                            zIndex: 1050
                        }}
                    >

                        {/* Settings */}
                        <button
                            className="dropdown-item"
                            onClick={() => {
                                setDropdownOpen(false);
                                navigate("/dashboard/settings");
                            }}
                        >
                            <i className="bi bi-gear me-2"></i>
                            Settings
                        </button>

                        <hr className="dropdown-divider" />

                        {/* Logout */}
                        <button
                            className="dropdown-item text-danger"
                            onClick={logout}
                        >
                            <i className="bi bi-box-arrow-right me-2"></i>
                            Logout
                        </button>

                    </div>

                )}

            </div>

        </nav>
    );
}

export default Topbar;
